import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { catchError, map } from 'rxjs';
import { constant } from 'src/app/constant/constant';
import { LabelPrintObject } from 'src/app/models/LabelPrintObject';
import { BaseHttpService } from 'src/app/utility/BaseHttpService';
import { map, timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class ItemService {

  constructor(private httpClient: HttpClient, private baseHttpService: BaseHttpService) { }

  getItems(item: any) {
    return this.baseHttpService.post<any>(constant.getBaseItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )

  }

  getItemPriceHistory(item: any) {
    return this.baseHttpService.post<any>(constant.getItemPriceHistoryUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getQuickAddItemsOnLoad(item: any) {
    return this.baseHttpService.post<any>(constant.getQuickAddItemsOnLoadUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getQuickAddItems(item: any) {
    return this.baseHttpService.post<any>(constant.getQuickAddItemsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  reactivateDeletedItem(item: any) {
    return this.baseHttpService.post<any>(constant.reactivateDeletedItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  createQuickAddItems(item: any) {
    return this.baseHttpService.post<any>(constant.createQuickAddItemsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateQuickAddItems(item: any) {
    return this.baseHttpService.post<any>(constant.createQuickAddItemsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  deleteQuickAddItems(item: any) {
    return this.baseHttpService.post<any>(constant.deleteQuickAddItemsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  createQuickAddGroups(item: any) {
    return this.baseHttpService.post<any>(constant.createUpdateQuickAddGroupUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateQuickAddGroups(item: any) {
    return this.baseHttpService.post<any>(constant.createUpdateQuickAddGroupUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  deleteQuickAddGroups(item: any) {
    return this.baseHttpService.post<any>(constant.deleteQuickAddGroupItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getItemMonitoringCategories(npiNumber: string) {
    return this.baseHttpService.post<any>(constant.getItemMonitoringCategoriesUrl, JSON.stringify(npiNumber), constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  insertItemMonitoringCategories(item: any) {
    return this.baseHttpService.post<any>(constant.insertItemMonitoringCategoriesUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateItemMonitoringCategories(item: any) {
    return this.baseHttpService.post<any>(constant.updateItemMonitoringCategoriesUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  deleteItemMonitoringCategories(item: any) {
    return this.baseHttpService.post<any>(constant.deleteItemMonitoringCategoriesUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  createItem(item: any) {
    return this.baseHttpService.post<any>(constant.createItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getAggregateItem(item: any) {
    return this.baseHttpService.post<any>(constant.getAggregateItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateItem(item: any) {
    return this.baseHttpService.post<any>(constant.updateItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  deleteItem(item: any) {
    return this.baseHttpService.post<any>(constant.deleteItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }


  insertDefaultItems(item: any) {
    return this.baseHttpService.post<any>(constant.insertDefaultItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getItemsForPO(item: any) {
    //https://localhost:8016/Items/getItemByNPIWithVendor
    //constant.getItemUrl
    return this.baseHttpService.post<any>(constant.getItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  generateLabels(item: any) {
    return this.baseHttpService.post<any>(constant.generateLabelsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  saveLabelTemplate(item: any) {
    return this.baseHttpService.post<any>(constant.saveLabelTemplateUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  deleteLabelTemplate(item: any) {
    return this.baseHttpService.post<any>(constant.deleteLabelTemplateUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  updateLabelTemplate(item: any) {
    return this.baseHttpService.post<any>(constant.updateLabelTemplateUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getByTemplateName(item: any) {
    return this.baseHttpService.post<any>(constant.getByTemplateNameUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getAllAggregateItem(item: any) {
    return this.baseHttpService.post<any>(constant.getAllAggregateItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updatePriceHistory(NPINO: any) {
    return this.baseHttpService.post<any>(constant.updatePriceHistory, NPINO, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  createLabelPDF(labelData: LabelPrintObject[]) {
    return this.httpClient.post(constant.createLabelPDFUrl, labelData,{responseType:'blob'});
  }

  getItemsByDeptId(item: any) {
    return this.baseHttpService.post<any>(constant.getItemByIDList, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getItemByNPI(item: any) {
    return this.baseHttpService.post<any>(constant.getAllNpiItemUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }


  getItemVendorData(item: any) {
    return this.baseHttpService.post<any>(constant.getItemVendorDataUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  createItemVendor(item: any) {
    return this.baseHttpService.post<any>(constant.insertItemVendorDataUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateLastVendor(poData: any) {
    return this.baseHttpService.post<any>(constant.updateLastVendorDataUrl, poData, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }


  CheckItemCodeExists(item: any) {
    return this.baseHttpService.post<any>(constant.CheckItemCodeExistsUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  getItemDetailsForPO(item: any) {
    return this.baseHttpService.post<any>(constant.getItemDetailsForPOUrl, item, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  //#region Items Import
  
  UploadChunk(formData: FormData) {
    //https://localhost:8014/Items/uploadChunk
    //constant.UploadChunkUrl
    return this.httpClient.post(constant.UploadChunkUrl, formData, {
      reportProgress: true,
      observe: 'response', // Ensure the full response is available
      responseType: 'json' // Ensure response is parsed as JSON
    });
  }
  

  // FinalizeUpload(payload: any) {
  //   //https://localhost:8014/Items/finalizeUpload
  //   return this.baseHttpService.post<any>(constant.FinalizeUploadUrl, payload, constant.httpClientHeader.headers).pipe(
  //     map((response: any) => {

  //       return response;
  //     })
  //   )
  // }

  FinalizeUpload(payload: any) {
    //constant.FinalizeUploadUrl
    //https://localhost:8014/Items/finalizeUpload
    const headersWithTimeout = constant.httpClientHeader.headers.set('timeout', '600000'); // 10 min
  
    return this.baseHttpService.post<any>(
      constant.FinalizeUploadUrl,
      payload,
      headersWithTimeout
    ).pipe(
      timeout(600000), // 10 minutes
      map((response: any) => response)
    );
  }
  
  getUploadStatus(fileId: string): Observable<any> {
    //https://localhost:8014/Items/upload/status/
    //constant.FileUploadStatusUrl
    return this.baseHttpService.get(constant.FileUploadStatusUrl+`${fileId}`);
  }

  //#endregion Items Import
  
  InsertNonEdiVendor(payload: any){
    //https://localhost:8014/Items/insertNonEdiVendor
    //constant.InsertNonEdiVendor
    return this.baseHttpService.post<any>(constant.InsertNonEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  UpdateNonEdiVendor(payload: any){
    //https://localhost:8014/Items/updateNonEdiVendor
    //constant.UpdateNonEdiVendor
    return this.baseHttpService.post<any>(constant.UpdateNonEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  DeleteNonEdiVendor(payload: any){
    //https://localhost:8014/Items/deleteNonEdiVendor
    //constant.DeleteNonEdiVendor
    return this.baseHttpService.post<any>(constant.DeleteNonEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  FetchAllNonEdiVendor(payload: any){
    //https://localhost:8014/Items/getAllNonEdiVendors
    //constant.FetchAllNonEdiVendor
    return this.baseHttpService.post<any>(constant.FetchAllNonEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  FetchAllInactiveEdiVendor(payload: any){
    //https://localhost:8014/Items/getAllInactiveNonEdiVendors
    //FetchAllInactiveEdiVendor
    return this.baseHttpService.post<any>(constant.FetchAllInactiveEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  FetchAllNpiNonEdiVendor(payload: any){
    //https://localhost:8014/Items/getNpiNonEdiVendor
    //constant.FetchAllNpiNonEdiVendor
    return this.baseHttpService.post<any>(constant.FetchAllNpiNonEdiVendor, payload, constant.httpClientHeader.headers).pipe(
      map((response: any) => {

        return response;
      })
    )
  }

  
  

}
